// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__2RFe1","cube1":"style_cube1__1EBox","cube2":"style_cube2__VFb71","sk-cubemove":"style_sk-cubemove__1z-0I"};